exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".shop-product-option-item ul{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-wrap:wrap;flex-wrap:wrap}.shop-product-option-item .option-item .btn-variant{margin:10px;padding:10px 20px;text-transform:uppercase;letter-spacing:1px;opacity:.3;-webkit-transition:all .3s ease-in-out;transition:all .3s ease-in-out}.shop-product-option-item .option-item .is-active{-webkit-transform:scale(1.2);transform:scale(1.2);opacity:1}", ""]);

// exports
